export default __webpack_public_path__ + "static/media/clip-bg.439af190.svg";